import {
  MultiangebotAdressenValidationResult,
  VhvRelevantVorbelegungdaten,
} from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';
import { selectIsAuslaendischeAdresse, selectRisikoortHasCoordinates } from './risikoort.selector';
import { selectIsDiplomatengeschaeft } from './vertragsoption.selector';

export const selectZurueckZumShopOpen = (state: IAppState): boolean =>
  state.transientState.zurueckZumShopModalOpen;

export const selectTarifierungIsInProgress = (state: IAppState): boolean =>
  state.transientState.tarifierungIsInProgress;

export const selectAdressvorschlagIsInProgress = (state: IAppState): boolean =>
  selectIsDiplomatengeschaeft(state) === true && selectIsAuslaendischeAdresse(state) === true
    ? selectRisikoortHasCoordinates(state) === false
    : state.transientState.adressvorschlagIsInProgress;

export const selectVhvVorhandenError = (state: IAppState): MultiangebotAdressenValidationResult =>
  state.transientState.vhvVorhandenError;

export const selectMapViewModalOpen = (state: IAppState): boolean =>
  state.transientState.mapViewModal.isOpen;

export const selectMapViewModalAdresseTarifierbar = (state: IAppState): boolean =>
  state.transientState.mapViewModal.isAdresseTarifierbar;

export const selectVhvRelevantVorbelegungdaten = (state: IAppState): VhvRelevantVorbelegungdaten =>
  state.transientState?.relevantVorbelegungdaten;

export const selectFormValidationTriggered = (state: IAppState): boolean =>
  state.transientState.formValidationTriggered;

